import { createContext } from '@lit/context';
import { CollectionsState, CuratedCollectionsState, ProductsState } from './wishlist-state.js';

export const productsContext = createContext<ProductsState>('productsContext');
export const collectionsContext = createContext<CollectionsState>('collectionsContext');
export const curatedCollectionContext = createContext<CuratedCollectionsState>('curatedCollectionContext');
